import subjectTypeIcons from '@Guidelines/Component/SubjectTypeTile/subjectTypeIcons';
import { FolderOpen, type LucideIcon } from 'lucide-react';

/** Icon of a subject type; an unknown value falls back to the folder. */
const resolveSubjectTypeIcon = (value: string): LucideIcon => {
	return subjectTypeIcons[value] ?? FolderOpen;
};

export default resolveSubjectTypeIcon;
